(() => {
  'use strict';
  let menuTrigger = null;
  const menu = () => document.getElementById('mobile-menu');
  function closeMenu() { const d = menu(); if (d?.open) d.close(); }
  document.addEventListener('click', event => {
    document.querySelectorAll('.native-mega[open]').forEach(dropdown => {
      if (!dropdown.contains(event.target) || event.target.closest('.native-mega-panel a')) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dropdown = document.querySelector('.native-mega[open]');
    if (!dropdown) return;
    event.preventDefault();
    dropdown.open = false;
    dropdown.querySelector('summary')?.focus();
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.native-mega[open]').forEach(dropdown => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  document.addEventListener('click', async event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('[data-open-menu]')) {
      menuTrigger = target;
      menu()?.showModal();
      target.setAttribute('aria-expanded', 'true');
    }
    if (target.matches('[data-close-menu]') || target.closest('#mobile-menu') && target.tagName === 'A') closeMenu();
    if (target.matches('[data-top]')) window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    if (target.matches('[data-media-select]')) selectMedia(target.closest('[data-gallery]'), target.dataset.mediaSelect);
    if (target.matches('[data-quantity-step]')) {
      const input = target.closest('form').querySelector('[name="quantity"]');
      input.value = Math.max(1, Math.min(99, (parseInt(input.value,10)||1) + Number(target.dataset.quantityStep)));
      updatePrice(target.closest('[data-product-section]'));
    }
    if (target.matches('[data-share-url]')) {
      const url = new URL(target.dataset.shareUrl, location.origin).href;
      const title = target.dataset.shareTitle;
      const status = target.parentElement.querySelector('[data-share-status]');
      try {
        if (navigator.share) { await navigator.share({title,url}); return; }
        if (navigator.clipboard?.writeText) {await navigator.clipboard.writeText(url);status.textContent='Link copied.';return;}
      } catch (error) { if (error.name==='AbortError') return; }
      status.textContent='Copy this link: ';
      const input = document.createElement('input'); input.readOnly=true; input.value=url;input.setAttribute('aria-label','Link to share');status.append(input);input.focus();input.select();
    }
  });
  function selectMedia(gallery, id) {
    if (!gallery || !gallery.querySelector(`[data-media-panel="${CSS.escape(String(id))}"]`)) return;
    gallery.querySelectorAll('[data-media-panel]').forEach(panel => {
      const selected=panel.dataset.mediaPanel===String(id);
      panel.hidden=!selected;
      if (!selected) {
        panel.querySelectorAll('video').forEach(video=>video.pause());
        // Removing and restoring external frames stops playback without provider APIs.
        panel.querySelectorAll('iframe').forEach(frame=>{const src=frame.getAttribute('src');if(src){frame.dataset.videoSrc=src;frame.removeAttribute('src');}});
      } else panel.querySelectorAll('iframe[data-video-src]').forEach(frame=>{frame.src=frame.dataset.videoSrc;delete frame.dataset.videoSrc;});
    });
    gallery.querySelectorAll('[data-media-select]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.mediaSelect===String(id))));
  }
  function scrollToPurchase(section) {
    const total=section.querySelector('.clarity-total');
    if (!total) return;
    requestAnimationFrame(()=>total.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'}));
  }
  // Clicking the selected pack should also take the customer to its total.
  document.addEventListener('click',event=>{
    const choice=event.target.closest('.clarity-choice');
    const option=choice?.querySelector('[name="id"]');
    if (option?.checked&&!option.disabled) scrollToPurchase(choice.closest('[data-product-section]'));
  });
  function updatePrice(section, changeVariant=false) {
    if (!section) return;
    const option=section.querySelector('[name="id"]:checked');
    if (!option) return;
    const input=section.querySelector('[name="quantity"]');
    const quantity=Math.max(1,Math.min(99,parseInt(input.value,10)||1));
    const price=Number(option.dataset.price),servings=Number(option.dataset.servings),count=Number(option.dataset.count),base=Number(option.dataset.base);
    const form=section.querySelector('.native-product-form');
    const pending=form?.dataset.productPending==='true';
    const available=option.dataset.available==='true';
    const addLabel=pending?(form?.dataset.addingLabel||'Add to bag'):available?'Add to bag':'Sold out';
    const money=c=>new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency:section.dataset.currency,currencyDisplay:'narrowSymbol'}).format(c/100);
    section.querySelector('[data-order-total]').textContent=money(price*quantity);
    const stickyTotal=section.querySelector('[data-sticky-total]');if(stickyTotal)stickyTotal.textContent=count*quantity+' '+(count*quantity===1?'pack':'packs')+' · '+servings*quantity+' sachets · '+money(price*quantity);
    const stickyAdd=section.querySelector('[data-sticky-add]');if(stickyAdd){stickyAdd.disabled=pending||!available;stickyAdd.textContent=addLabel;}
    const packName=option.dataset.packName || option.closest('label')?.querySelector('.pack-name b')?.textContent || '';
    section.querySelector('[data-order-summary]').textContent=(section.dataset.copySummary || '').replace('__QUANTITY__',quantity).replace('__NAME__',packName).replace('__COUNT__',servings*quantity);
    const reference=base*count*quantity;
    const saving=base>0&&count>1?Math.max(0,reference-price*quantity):0;
    const savingNode=section.querySelector('[data-order-saving]');
    savingNode.hidden=saving<=0;
    savingNode.textContent=saving>0?(section.dataset.copySaving || '').replace('__PERCENT__',Math.round(saving/reference*100)).replace('__AMOUNT__',money(saving)):'';
    const referenceNode=section.querySelector('[data-order-reference]');
    if(referenceNode){referenceNode.hidden=saving<=0;referenceNode.textContent=saving>0?money(reference):'';}
    const shipping=section.querySelector('[data-purchase-shipping]');
    if(shipping){const eligible=section.dataset.currency==='AUD'&&price*quantity>9000;shipping.dataset.eligible=String(eligible);shipping.querySelector('[data-shipping-message]').textContent=eligible?section.dataset.copyShipping:section.dataset.copyThreshold;}
    const add=section.querySelector('[data-add-button]');add.disabled=pending||!available;add.textContent=pending||!available?addLabel:(section.dataset.copyAdd || '').replace('__AMOUNT__',money(price*quantity));
    if(changeVariant){
      const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
      if(option.dataset.mediaId)selectMedia(section.querySelector('[data-gallery]'),option.dataset.mediaId);
      scrollToPurchase(section);
    }
  }
  function init(root=document) {
    const d=menu();
    if(d&&!d.dataset.initialized){d.dataset.initialized='true';d.addEventListener('close',()=>{menuTrigger?.setAttribute('aria-expanded','false');menuTrigger?.focus({preventScroll:true});});d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeMenu();}});}
    root.querySelectorAll('[data-product-section]').forEach(s=>{updatePrice(s);
      if(!s.dataset.observed&&'IntersectionObserver' in window){s.dataset.observed='true';const sticky=s.querySelector('[data-sticky-buy]');const area=s.querySelector('.purchase-actions');if(sticky&&area){const observer=new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>=0;});observer.observe(area);}}const checked=s.querySelector('[name="id"]:checked');if(checked?.dataset.mediaId)selectMedia(s.querySelector('[data-gallery]'),checked.dataset.mediaId);});
  }
  document.addEventListener('change',event=>{const section=event.target.closest('[data-product-section]');if(!section)return;if(event.target.name==='quantity')event.target.value=Math.max(1,Math.min(99,parseInt(event.target.value,10)||1));if(['quantity','id'].includes(event.target.name))updatePrice(section,event.target.name==='id');});
  document.addEventListener('input',event=>{if(event.target.name==='quantity')updatePrice(event.target.closest('[data-product-section]'));});
  document.addEventListener('coreffect:product-pending-change',event=>updatePrice(event.target.closest('[data-product-section]')));
  document.addEventListener('shopify:section:load',event=>init(event.target));
  init();
})();

